module.exports = __webpack_public_path__ + "img/bg.f0109672.jpg";